var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthInsuranceButtonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "4.43rem",
    viewBox: "0 0 54.139 61.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7",
    transform: "translate(-0.501 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3912",
    "data-name": "Path 3912",
    d: "M228.662,200.411a1.2,1.2,0,0,0-1.2-1.2H216.943a1.2,1.2,0,1,0,0,2.392h10.523A1.2,1.2,0,0,0,228.662,200.411Zm0,0",
    transform: "translate(-189.522 -175.407)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    "data-name": "Path 3913",
    d: "M71.825,99.125H69.608a2.478,2.478,0,0,0-2.478,2.473v1.151H65.978a2.48,2.48,0,0,0-2.478,2.477v2.219a2.48,2.48,0,0,0,2.478,2.477h1.153v1.151a2.48,2.48,0,0,0,2.478,2.477h2.217a2.48,2.48,0,0,0,2.478-2.477v-1.151h1.153a2.48,2.48,0,0,0,2.478-2.477v-2.219a2.48,2.48,0,0,0-2.478-2.477H74.3V101.6A2.478,2.478,0,0,0,71.825,99.125Zm3.631,6.017a.088.088,0,0,1,.085.084v2.219a.088.088,0,0,1-.085.084H73.107a1.2,1.2,0,0,0-1.2,1.2v2.347a.088.088,0,0,1-.085.084H69.608a.088.088,0,0,1-.085-.084v-2.347a1.2,1.2,0,0,0-1.2-1.2H65.978a.088.088,0,0,1-.085-.084v-2.219a.088.088,0,0,1,.085-.084h2.349a1.2,1.2,0,0,0,1.2-1.2V101.6a.087.087,0,0,1,.085-.081h2.217a.088.088,0,0,1,.085.081v2.348a1.2,1.2,0,0,0,1.2,1.2Zm0,0",
    transform: "translate(-55.47 -87.278)",
    fill: "#81b830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M229.183,140.684a1.2,1.2,0,0,0-1.2-1.2H216.942a1.2,1.2,0,0,0,0,2.393h11.045A1.2,1.2,0,0,0,229.183,140.684Zm0,0",
    transform: "translate(-189.522 -122.818)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    d: "M71.419,261.3H98.808a1.2,1.2,0,0,0,0-2.393H71.419a1.2,1.2,0,1,0,0,2.393Zm0,0",
    transform: "translate(-61.39 -227.968)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    d: "M53.623,37.793a30.56,30.56,0,0,1-6.866-1.73v-10.4a1.2,1.2,0,1,0-2.393,0v9.083a5.912,5.912,0,0,1-.711-.633,1.2,1.2,0,0,0-1.738,0c-1.585,1.675-4.941,2.914-9.973,3.681a1.19,1.19,0,0,0-.608.284H10.03a1.2,1.2,0,1,0,0,2.392h20.9v4.742H9.226a1.2,1.2,0,1,0,0,2.392h21.8A15.044,15.044,0,0,0,35.18,55.94H6.3a3.411,3.411,0,0,1-3.411-3.4V8.439A3.411,3.411,0,0,1,6.3,5.035h5.709v.443a2.2,2.2,0,0,0,2.2,2.2H33.045a2.2,2.2,0,0,0,2.2-2.2V5.035h5.709a3.412,3.412,0,0,1,3.411,3.4v7.679a1.2,1.2,0,1,0,2.392,0V8.439a5.806,5.806,0,0,0-5.8-5.8H35.245V2.2a2.2,2.2,0,0,0-2.2-2.2H14.213a2.2,2.2,0,0,0-2.2,2.2v.447H6.3a5.807,5.807,0,0,0-5.8,5.8v44.1a5.806,5.806,0,0,0,5.8,5.8H37.75c2.154,1.848,3.483,2.856,5.026,2.858h0c1.736,0,3.2-1.265,5.851-3.559,3.748-3.245,5.769-6.945,6-11,0-.023,0-.046,0-.07V38.975a1.2,1.2,0,0,0-1.016-1.182ZM14.406,2.393H32.852V5.281H14.406ZM52.247,46.527c-.207,3.371-1.95,6.5-5.181,9.294-2.071,1.792-3.44,2.976-4.286,2.976h0c-.839,0-2.133-1.121-4.277-2.976-3.23-2.8-4.974-5.923-5.184-9.294V39.993c4.374-.753,7.492-1.887,9.466-3.446a11.7,11.7,0,0,0,2.183,1.335,1.174,1.174,0,0,0,.17.08,28.476,28.476,0,0,0,7.109,2.031Zm0,0",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3917",
    "data-name": "Path 3917",
    d: "M312.278,361.7l-2.1-1.974a1.2,1.2,0,0,0-1.637,1.745l2.99,2.8a1.2,1.2,0,0,0,.818.324h.048a1.2,1.2,0,0,0,.838-.39l6.065-6.667a1.2,1.2,0,0,0-1.77-1.61Zm0,0",
    transform: "translate(-270.89 -313.047)",
    fill: "#81b830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3918",
    "data-name": "Path 3918",
    d: "M368.727,164.6a1.2,1.2,0,0,0-1.2,1.2v.02a1.2,1.2,0,0,0,2.393,0v-.02A1.2,1.2,0,0,0,368.727,164.6Zm0,0",
    transform: "translate(-323.166 -144.93)",
    fill: "#199b8b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthInsuranceButtonIcon);
export default __webpack_public_path__ + "static/media/health-insurance-button-icon.a768d620ef0e73c3d3c99cdc62cdceff.svg";
export { ForwardRef as ReactComponent };